module.exports = __webpack_public_path__ + "img/Handling-fee-rebate-icon@2x.02588846.svg";